<template>
  <v-container>
      <v-row v-if="tesseraUtente === false" class="justify-center" >{{$t("click_on_card_you_want")}}
      </v-row><v-row v-if="tesseraUtente === false" class="justify-center">
      <base-material-card
        color="transparent"
        class="tessera" 
        :style="'margin: 50px; width:' + (tessera.orientation === 'vertical' ? 279.5 : 397)+'px'" 
        image
        :v-if="tessere.length > 0"
        v-for="tessera in tessere"
        v-bind:key="tessera.tesId"
      >
        <template v-slot:image>
          <a v-if="!tessera.waitingApproval && !tessera.alreadyGet" @click="selectTessera(tessera)">
            <v-img :src="tessera.image" :height="tessera.orientation === 'vertical' ? 397 : 279.5" :width="tessera.orientation === 'vertical' ? 279.5 : 397"/>
          </a>
          <div v-else>
            
            <v-img :src="tessera.image" :height="tessera.orientation === 'vertical' ? 397 : 279.5" :width="tessera.orientation === 'vertical' ? 279.5 : 397" style="filter: grayscale(98%)" />
          <div  v-if="tessera.alreadyGet" style="position:absolute; top: 10px; left: 10px;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
            <v-icon large color="error" class="mr-2" v-bind="attrs" v-on="on">
              mdi-cancel
            </v-icon>
            </template>
            <span>{{ $t("already_owned") }}</span>
          </v-tooltip>
            
        </div>
          </div>
        </template>
        <v-card-title class="justify-center font-weight-light">{{
          tessera.title
        }}</v-card-title>
        <v-card-text
          v-if="tessera.descr"
          v-html="tessera.descr"
          class="body-1 text-center mb-3 font-weight-light grey--text"
        ></v-card-text>
        <template v-slot:actions style="height: 50px">
          <div  v-if="tessera.waitingApproval" >
            <v-icon
            large
            color="warning" 
            class="mr-2">
            mdi-clock-time-three-outline
          </v-icon>
        </div> 
        <div v-if="tessera.alreadyGet">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon large color="success" class="mr-2" v-bind="attrs" v-on="on">
              mdi-check-decagram
            </v-icon>
          </template>
          <span>{{ $t("already_owned") }}</span>
        </v-tooltip>
          
         
        </div>
            <v-spacer/>
          <div
            class="display-2 font-weight-light grey--text"
            v-html="tessera.prezzo"
          />
          <v-spacer />

          <span
            v-if="tessera.idProduct"
            class="caption grey--text font-weight-light"
          >
            <v-icon large color="red">mdi-gift</v-icon>
          </span>
        </template>
      </base-material-card>
      </v-row>
      <div v-if="tessere.length === 0 && upgrade">
        NESSUNA TESSERA DISPONIBILE
      </div>
      
  </v-container>
</template>

<script>
export default {
  name: "list-tessere",

  props: {
    auth: {
      type: Boolean,
      default: false,
    },
    masterId: {
      type: Number,
      default: null,
    },
    upgrade: {
      type: Boolean,
      default: false,
    },
    disableRedirect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tessere: null,
      tesseraUtente: false,
    };
  },
  watch: {
    masterId: function (changed) {
      this.loadData();
    },
  },
  methods: {
    selectTessera(tessera) {
      if (!this.upgrade && !this.disableRedirect)
        this.$router.push("/portal/tesserati/tesseramento");
      else {
        this.$emit("selected", tessera);
      }
    },
    loadData() {
      let _ = this;
      let url = "/public/tesseramenti/listTessere";
      if (_.auth) url = "/auth/tesseramenti/listTessere";
      if (_.upgrade) {
        url = "/auth/tesseramenti/listTessereUpgrade";
        if (_.masterId) url += "/" + _.masterId;
      }
      _.tessere = [];
      this.chiamataAxios("GET", url).then((response) => {
        if (!_.upgrade && _.auth && response.data.tesseraUtente)
          _.tesseraUtente = true;
        else _.tesseraUtente = false;
        for (let t = 0; t < response.data.tessere.length; t++) {
          let tessera = {
            title: response.data.tessere[t].nome,
            descr: response.data.tessere[t].descr,
            tesId: response.data.tessere[t].tesId,
            image: response.data.tessere[t].image,
            buyWithCredits: response.data.tessere[t].buyWithCredits,
            waitingApproval: response.data.tessere[t].waitingApproval,
            alreadyGet: response.data.tessere[t].alreadyGet,
            orientation: response.data.tessere[t].orientation,
          };
          if (response.data.tessere[t].prezzo) {
            tessera.prezzo = response.data.tessere[t].prezzo;
          }
          if (response.data.tessere[t].idProduct) {
            tessera.idProduct = response.data.tessere[t].idProduct;
          }

          _.tessere.push(tessera);
        }
      });
    },
  },
  created() {
    this.loadData();
  },
};
</script>
<style scoped>
.xtessera {
  width: 300px;
}
.waiting-approval-icon {
  font-size: 50px;
  position: absolute;
  top: 0px;
  margin: 10px;
}
</style>